import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { IconButton } from '@hvcgroep/design-system';
import { APP_ID } from '../../../../../shared/config/constants';
import gtm from '../../../../../shared/helpers/gtm';

export interface NavigationViewYearProps {
  currentDate: Date;
  updateDate: (date: Date) => void;
}

const NavigationViewYear: React.FC<NavigationViewYearProps> = (props) => {
  const {
    currentDate = new Date(),
    updateDate,
  } = props;

  const { t } = useTranslation();

  const classNames = c('Navigation', 'Navigation--ViewYear');
  const today = new Date();

  return (
    <nav className={classNames}>
      <IconButton
        icon="keyboard_arrow_left"
        disabled={currentDate.getFullYear() === today.getFullYear()}
        onClick={() => {
          const newDate = new Date();
          newDate.setFullYear(currentDate.getFullYear() - 1);
          newDate.setMonth(new Date().getMonth());

          gtm.trackUserEvent(String(APP_ID), 'Year navigation click', t('waste_calendar.navigation.prev'));
          updateDate(newDate);
        }}
      >
        {t('waste_calendar.navigation.prev')}
      </IconButton>

      <h2 className="CalendarWidget__header__date" id="current-month">
        {t('waste_calendar.titles.year_calendar')} <span>{currentDate.getFullYear()}</span>
      </h2>

      <IconButton
        icon="keyboard_arrow_right"
        disabled={currentDate.getFullYear() === today.getFullYear() + 1}
        onClick={() => {
          const newDate = new Date();
          newDate.setFullYear(currentDate.getFullYear() + 1);
          newDate.setMonth(0);

          gtm.trackUserEvent(String(APP_ID), 'Year navigation click', t('waste_calendar.navigation.next'));
          updateDate(newDate);
        }}
      >
        {t('waste_calendar.navigation.next')}
      </IconButton>
    </nav>
  );
};

export default NavigationViewYear;
